module.exports = __webpack_public_path__ + "img/behold-15.d3bc92b8.png";